import { useSelector } from "react-redux";
import store from "../../stores/store";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { useEffect } from "react";
import { formatSelectedFeatures, key, trans } from "../../lib/utils";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import { showMeasurementFeature } from "../map/measurementsUtil";

function MeasurementResults() {
  const results = useSelector((state) => store.getState().map.measurements);

  useEffect(() => {
    window["recaclulatePerfectScrollbarHeight"]();
  }, []);

  return (
    <div className="mt-2">
      <button
        className="btn btn-sm btn-link border mb-1 me-2"
        onClick={(e) => {
          store.dispatch({ type: "map/measurements/clearall" });
          window["measurementsSource"].clear();
        }}
      >
        {trans("Clear Measurements")}
      </button>
      <PerfectScrollbar className="scrollbar-recaclulate">
        <BootstrapTable
          key={key()}
          keyField="_featureId"
          data={results}
          columns={[
            {
              dataField: "_featureId",
              text: "",
              hidden: true,
            },
            {
              dataField: "_feature",
              text: "",
              hidden: true,
            },
            {
              dataField: "_zoomToFeature",
              text: "",
              headerStyle: (colum, colIndex) => {
                return { width: "30px", textAlign: "center" };
              },
              formatter: function (cell, row) {
                return (
                  <i
                    className="fas fa-compress  m-auto"
                    role="button"
                    onClick={(e) => {
                      showMeasurementFeature(row._feature, row.type);
                    }}
                  ></i>
                );
              },
            },
            {
              dataField: "type",
              text: trans("Type"),
            },
            {
              dataField: "measurement",
              text: trans("Measurement"),
            },
          ]}
          wrapperClasses="bg-white"
          striped
          hover
        />
      </PerfectScrollbar>
    </div>
  );
}

export default MeasurementResults;
